import React from 'react';
import { useTranslation } from 'react-i18next';

export const TermsPage = () => {
  const { t } = useTranslation();
  return (
  <div className="max-w-[800px] mx-auto py-[32px] md:py-[48px]">
    <h1 className="font-display text-[28px] md:text-[36px] font-bold text-base-black tracking-[-0.5px] mb-[4px]">
      {t('terms.title')}
    </h1>
    <p className="font-body text-[13px] text-[#818185] mb-[32px]">{t('terms.lastUpdated')}</p>

    <article className="font-body text-[14px] text-[#374151] leading-relaxed flex flex-col gap-[24px]">
      <p>
        {t('terms.intro')}
      </p>
      <p className="uppercase font-semibold text-base-black text-[13px]">
        {t('terms.acceptance')}
      </p>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.definitionsTitle')}</h2>
        <p>{t('terms.defService')}</p>
        <p className="mt-[8px]">{t('terms.defUser')}</p>
        <p className="mt-[8px]">{t('terms.defAccount')}</p>
        <p className="mt-[8px]">{t('terms.defReview')}</p>
        <p className="mt-[8px]">{t('terms.defContent')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.useTitle')}</h2>
        <p>{t('terms.useIntro')}</p>
        <ul className="list-disc ml-[20px] mt-[8px] flex flex-col gap-[4px]">
          <li>{t('terms.useItem1')}</li>
          <li>{t('terms.useItem2')}</li>
          <li>{t('terms.useItem3')}</li>
          <li>{t('terms.useItem4')}</li>
          <li>{t('terms.useItem5')}</li>
          <li>{t('terms.useItem6')}</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.accountsTitle')}</h2>
        <p>{t('terms.accountsP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.reviewsContentTitle')}</h2>
        <p>{t('terms.reviewsContentP1')}</p>
        <p className="mt-[8px]">{t('terms.reviewsContentP2')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.teamsTitle')}</h2>
        <p>{t('terms.teamsP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.pricingTitle')}</h2>
        <p>{t('terms.pricingP1')}</p>
        <p className="mt-[8px]">{t('terms.pricingP2')}</p>
        <p className="mt-[8px]">{t('terms.pricingP3')}</p>
        <p className="mt-[8px]">{t('terms.pricingP4')}</p>
        <p className="mt-[8px]">{t('terms.pricingP5')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.refundsTitle')}</h2>
        <p>{t('terms.refundsP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.dataTitle')}</h2>
        <p>{t('terms.dataP1')} <a href="/privacy" className="text-base-black font-semibold underline">{t('footer.privacy')}</a>.</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.disclaimerTitle')}</h2>
        <p className="uppercase text-[13px]">
          {t('terms.disclaimerP1')}
        </p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.liabilityTitle')}</h2>
        <p className="uppercase text-[13px]">
          {t('terms.liabilityP1')}
        </p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.terminationTitle')}</h2>
        <p>{t('terms.terminationP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.governingTitle')}</h2>
        <p>{t('terms.governingP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.changesTitle')}</h2>
        <p>{t('terms.changesP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('terms.contactTitle')}</h2>
        <p>{t('terms.contactP1')} <a href="mailto:contact@squarebitstudios.com" className="text-base-black font-semibold underline">contact@squarebitstudios.com</a>.</p>
      </section>
    </article>
  </div>
  );
};
